export default function TableBody(theme) {
	return {
		MuiTableBody: {
			styleOverrides: {
				root: {}
			}
		}
	};
}
